// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3dzpZ","header":"MergedInvoice_header__1YXWv"};